import { useState } from "react";
import { useSelector } from "react-redux";
import Pagination from "../../../StyledComponents/Pagination";
import SuperBillTable from "./SuperBillTable";
import { BillingFooter, BillingFooterSpacer } from "../styles";

const SuperBill = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(5);

  const statementListDetails = useSelector(
    (state) => state.Billing.StatementList || []
  );

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = statementListDetails.slice(
    indexOfFirstPost,
    indexOfLastPost
  );
  const howManyPages = Math.ceil(statementListDetails.length / postsPerPage);

  return (
    <>
      <SuperBillTable StatementList={currentPosts} />
      <BillingFooter>
        {currentPosts.length !== 0 && howManyPages > 1 ? (
          <Pagination pages={howManyPages} setCurrentPage={setCurrentPage} />
        ) : (
          <BillingFooterSpacer />
        )}
      </BillingFooter>
    </>
  );
};

export default SuperBill;
